import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useFirebase } from "@meddbriefer/mdb-firebase";
import { deleteDocument } from "@meddbriefer/scenario-data"

const COLLECTION_ID = 'scenarios';

export default function ScenariosList() {
	const {db} = useFirebase()
	const [scenarios, setScenarios] = useState();

	async function deleteScenario(index) {
		let id = scenarios[index].id;
		if (window.confirm(`Are you sure you want to delete this scenario? This cannot be undone!`)) {
			await deleteDocument(db, COLLECTION_ID, id);
			// Hide in list of scenarios
			let newList = scenarios.slice(); // Deep copy
			newList.splice(index, 1);
			setScenarios(newList);
		} else {
			console.log(`Delete of ${id} cancelled.`);
		}
	}

	useEffect(
		() => {
			db.collection(COLLECTION_ID).orderBy("name").get()
			.then(snapShot => {
				let docs = []
				snapShot.docs.forEach(doc => {
					let tmp = doc.data()
					let data = {
						id: doc.id,
						name: tmp.name,
						scenarioType: tmp.scenarioType,
						scenarioVersion: tmp.scenarioVersion
					}
					docs.push(data)
				})
				setScenarios(docs)
			})
			.catch(error => console.log(error))
		}, [db]
	)

	return (
		<div className="db-list">
			<h1>Scenario List</h1>

			<Link to='/scenario/' className="new-bttn db-list-item">
				<h1>New Scenario</h1>
			</Link>

			{ scenarios
			? scenarios.map((item, index) => (
				item && <ListItem item={item} key={`${item.name}-list`} remove={deleteScenario} index={index} />))
			: <p>Loading...</p> }
		</div>
	);


};

const ListItem = ({ item, remove, index }) => {
	return (
		<div className="db-list-item">
			<h1 id="title">{item.name}</h1>
			<h1 className="hint-text">{item.scenarioType}</h1>
			{/* <p>Info: {item.info.instructorInformation ?? "Not given."}</p> */}

			<div className="list-button-wrapper">
				<Link to={`/scenario/${item.id}`} className="action-bttn">Edit</Link>
				<Link to={`/scenario/${item.id}/clone`} className="action-bttn">Use as Template</Link>
				<Link to={`/scenario/${item.id}/publish`} className="action-bttn">Publish</Link>
				<button type="button" className="action-bttn delete-bttn" onClick={() => remove(index) }>Delete</button>
			</div>
		</div>
	);
};

